<div class="modal-header">
    <h5 class="modal-title">Tahsilat Hareketleri</h5>
    <button type="button" class="close" (click)="activeModal.dismiss()">&times;</button>
</div>
<div class="modal-body">
    <table class="table table-sm table-bordered" *ngIf="movements.length > 0">
        <thead>
            <tr>
                <th>Kullanıcı</th>
                <th>Hesap</th>
                <th>Tutar</th>
                <th>Tür</th>
                <th>Tarih</th>
                <th>#</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of movements">
                <td>{{item.name}} {{item.lastName}}</td>
                <td>{{item.title}}</td>
                <td>{{item.balance | currency:currency :'symbol':'1.2-2'}}</td>
                <td>{{item.typeName}}</td>
                <td>{{item.cratedAt | date:'dd.MM.yyyy HH:mm'}}</td>
                <td>
                    <button class="btn btn-icon btn-flat-danger" appDelete controller="CompanyVaultMovements"
                        *ngIf="authService.isEndpointStatus('DELETE.Deleteing.DeleteCompanyVault')" [id]="item.id"
                        (callback)="callBackFun()">
                        <span [data-feather]="'trash'"></span>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="activeModal.close()">Kapat</button>
</div>